import { render, staticRenderFns } from "./LbaDragAndDropList2.vue?vue&type=template&id=409f4278"
import script from "./LbaDragAndDropList2.vue?vue&type=script&lang=js"
export * from "./LbaDragAndDropList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports